import { t } from "../../translations";
import { Aa } from "../functions/Aa";
import "../styles/promo-bar.css";

const PromoBar = (props) => {
  const { list, lang } = props;

  const randomIndex = Math.floor(Math.random() * list.length);
  const randomValue = list[randomIndex];

  return (
    <div className="promo-bar">
      <p>
        {t("promo_bar.prefix", lang)}
        <b>{randomValue?.value}$</b>
        {t("promo_bar.middle", lang)}
        <b> {Aa(randomValue?.code)} </b>
        {t("promo_bar.suffix", lang)}
      </p>
    </div>
  );
};

export default PromoBar;
